import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageDto } from '@asset-metrix/portal-gateway-client-js';

import { getDetailPageNavigationIdentity } from '../utils/detailPageNavigationIdentity';
import { getDetailsFromSearchParams } from '../utils/getDetailsFromSearchParams';

export function useGetPageCacheKey(
  pageType: string,
  pageId: string | null,
  pageData?: PageDto
) {
  const [urlSearchParams] = useSearchParams();

  const cacheKey = useMemo(() => {
    if (pageType === 'detailPage') {
      const { detailsDiscriminator, detailsValue } =
        getDetailsFromSearchParams(urlSearchParams);
      if (detailsDiscriminator == null || detailsValue == null) {
        const message =
          detailsDiscriminator == null
            ? 'A detail page was opened without specifying proper details parameters: Details discriminator is missing.'
            : `A detail page was opened without specifying proper details parameters: Value for details discriminator "${detailsDiscriminator}" is missing.`;

        throw new Error(message);
      }

      const detailPageIdentity = getDetailPageNavigationIdentity(
        urlSearchParams,
        pageData,
        { isCurrentPage: true }
      );

      // Wait until the final detail-page identity is available so consumers do not
      // briefly key state off the legacy discriminator/value fallback.
      if (detailPageIdentity == null) {
        return null;
      }

      return `${pageId}/${detailPageIdentity.signature}`;
    }
    return pageId;
  }, [pageType, pageId, pageData, urlSearchParams]);

  return cacheKey;
}
